import { render, staticRenderFns } from "./text-match-type.vue?vue&type=template&id=66595926&"
import script from "./text-match-type.vue?vue&type=script&lang=js&"
export * from "./text-match-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66595926')) {
      api.createRecord('66595926', component.options)
    } else {
      api.reload('66595926', component.options)
    }
    module.hot.accept("./text-match-type.vue?vue&type=template&id=66595926&", function () {
      api.rerender('66595926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/components/generic/text-match-type.vue"
export default component.exports